import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import {  throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
@Injectable({
  providedIn: 'root',
})
export class ProfilingService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  saveMandatoryClientFields(tenantId: number, data: any) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.PROFILING.CREATE_MANDATORY_FIELD
          .replace('{tenant_id}', tenantId.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  updateMandatoryClientFields(tenantId: number, clientFieldId :number, data: any) {
    return this.http
      .put(
        environment.BASE_URL + CONST_URL_SEGEMENTS.PROFILING.UPDATE_MANDATORY_FIELD
          .replace('{tenant_id}', tenantId.toString())
          .replace('{field_id}', clientFieldId.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getMandatoryClientFields(tenantId: number, pageType: string) {

    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.PROFILING.GET_MANDATORY_FIELDS
          .replace('{tenant_id}', tenantId.toString()) + `?page_type=${pageType}`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
